import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBathWoman1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBathWoman1"><Path d="M12 1C10.3431 1 9 2.34315 9 4C9 5.65685 10.3431 7 12 7C13.6569 7 15 5.65685 15 4C15 2.34315 13.6569 1 12 1Z" fill="currentColor"/><Path d="M8.21875 8L5.21875 20H7.99953V23H15.9995V20H18.7803L15.7803 8H8.21875Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBathWoman1;
